import { useRouteLoaderData, useOutletContext } from "react-router-dom";

export function useUser() {
  try {
    const routeData = useRouteLoaderData("admin");
    if (routeData) return routeData;
  } catch (e) {}

  try {
    const ctx = useOutletContext();
    if (!ctx || !ctx.user) {
      console.warn("useUser: no user in outlet context");
      return null;
    }
    return ctx.user;
  } catch (err) {
    console.warn("useUser called outside admin loader/context:", err);
    return null;
  }
}